export default __webpack_public_path__ + "static/media/paid.f16298f5.svg";